import { create } from 'zustand';

const usePaymentsHistoryStore = create((set) => {
    return {
        paymentsHistory: [],
        setPaymentsHistory: (paymentsHistory) => {
            const timestamp = new Date().getTime();
            const updatedPaymentsHistory = paymentsHistory.map((paymentHistory) => ({
                ...paymentHistory,
                timestamp
            }));
            set({ paymentsHistory: updatedPaymentsHistory });
        },
        addPaymentHistory: (paymentHistory) => {
            const timestamp = new Date().getTime();
            const updatedPaymentHistory = { ...paymentHistory, timestamp };
            set((state) => ({
                paymentsHistory: [...state.paymentsHistory, updatedPaymentHistory]
            }));
        },
        clearPaymentsHistory: () => {
            set({ paymentsHistory: [] });
        },
    };
});

export default usePaymentsHistoryStore;